module.exports = __webpack_public_path__ + "static/main-header-01-8be32241cf84bcda196e5f5cec9cb644.jpg";